import React from 'react';
import { Link } from 'react-router-dom';
import { Check, ArrowRight, Home, Wrench } from 'lucide-react';
import { services } from '../data/mock';

const Services = () => {
  return (
    <section
      id="services"
      className="section-padding relative grid-pattern"
      style={{ backgroundColor: '#1F3B60' }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center mb-16">
          <span className="inline-block font-semibold text-xs tracking-[0.2em] uppercase mb-4 px-4 py-1.5 rounded-full" style={{ color: '#D6A94F', backgroundColor: 'rgba(214, 169, 79, 0.1)', border: '1px solid rgba(214, 169, 79, 0.2)' }}>
            Our Services
          </span>
          <h2 className="font-display font-bold text-4xl sm:text-5xl text-white mb-6">
            Two Paths to Your Real Estate Goals
          </h2>
          <div className="divider-gold mx-auto mb-6" />
          <p className="max-w-2xl mx-auto text-lg text-white/60">
            Whether you&apos;re looking to sell quickly or transform your property, we offer tailored solutions to meet your needs.
          </p>
        </div>

        {/* Two-pillar cards */}
        <div id="sell" className="grid md:grid-cols-2 gap-8">
          {/* Property Offers Card */}
          <div className="card-navy p-8 lg:p-10 group hover:border-white/20 transition-all duration-500 hover:-translate-y-2">
            <div className="flex items-center space-x-4 mb-4">
              <div className="w-14 h-14 rounded-2xl flex items-center justify-center shadow-lg" style={{ background: 'linear-gradient(135deg, #D6A94F, #E4C078)' }}>
                <Home className="w-7 h-7" style={{ color: '#1F3B60' }} />
              </div>
              <h3 className="font-display font-bold text-2xl text-white">
                {services.offers.title}
              </h3>
            </div>
            
            {/* SEO Keyword Subheadings */}
            <h4 className="text-lg font-semibold text-white/90 mb-2">Sell Your Home Quickly in Los Angeles</h4>
            <h5 className="text-base text-white/70 mb-6">As-Is Property Solutions for LA Homeowners</h5>

            <p className="text-white/70 leading-relaxed mb-8">
              {services.offers.description}
            </p>

            <ul className="space-y-4 mb-10">
              {services.offers.features.map((feature, index) => (
                <li key={index} className="flex items-start space-x-3">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center mt-0.5" style={{ backgroundColor: 'rgba(214, 169, 79, 0.1)' }}>
                    <Check className="w-3.5 h-3.5" style={{ color: '#D6A94F' }} />
                  </div>
                  <span className="text-white/80">{feature}</span>
                </li>
              ))}
            </ul>

            <Link
              to={services.offers.cta.href}
              className="btn-gold inline-flex items-center space-x-2 group/btn"
            >
              <span>{services.offers.cta.text}</span>
              <ArrowRight className="w-4 h-4 group-hover/btn:translate-x-1 transition-transform" />
            </Link>
          </div>

          {/* Renovation Card */}
          <div id="renovation" className="card-navy p-8 lg:p-10 group hover:border-white/20 transition-all duration-500 hover:-translate-y-2">
            <div className="flex items-center space-x-4 mb-4">
              <div className="w-14 h-14 rounded-2xl flex items-center justify-center shadow-lg" style={{ background: 'linear-gradient(135deg, #D6A94F, #E4C078)' }}>
                <Wrench className="w-7 h-7" style={{ color: '#1F3B60' }} />
              </div>
              <h3 className="font-display font-bold text-2xl text-white">
                {services.renovation.title}
              </h3>
            </div>
            
            {/* SEO Keyword Subheading */}
            <h4 className="text-lg font-semibold text-white/90 mb-6">Renovation Services for Los Angeles Homes</h4>

            <p className="text-white/70 leading-relaxed mb-8">
              {services.renovation.description}
            </p>

            <ul className="space-y-4 mb-10">
              {services.renovation.features.map((feature, index) => (
                <li key={index} className="flex items-start space-x-3">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center mt-0.5" style={{ backgroundColor: 'rgba(214, 169, 79, 0.1)' }}>
                    <Check className="w-3.5 h-3.5" style={{ color: '#D6A94F' }} />
                  </div>
                  <span className="text-white/80">{feature}</span>
                </li>
              ))}
            </ul>

            <Link
              to={services.renovation.cta.href}
              className="btn-gold inline-flex items-center space-x-2 group/btn"
            >
              <span>{services.renovation.cta.text}</span>
              <ArrowRight className="w-4 h-4 group-hover/btn:translate-x-1 transition-transform" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
